<template>
	<div class="Quota">
		<div class="content-menu" v-if="menuList.length>1">
			<div class="menu-item" :class="[current===index?'current':'']" v-for="(item,index) in menuList" :key="index"
				@click="handClick(index)">
				{{item.title}}
			</div>
		</div>
		<component :is="menuList[current].component" :auth="menuList[current].auth"></component>
	</div>
</template>

<script>
	import quotaDefaultRatio from '../QuotaDefaultRatio/QuotaDefaultRatio.vue';
	import quotaMonth from './components/quotaMonth.vue';
	import quotaIms from './components/quotaIms.vue';
	import quotaSummary from './components/quotaSummary.vue';
	import quotaApply from '../QuotaApply/QuotaApply.vue';
	import quotaCreate from '../QuotaCreate/QuotaCreate.vue';
	import quotaHistory from './components/quotaHistory.vue';

	export default {
		data() {
			return {
				current: 0,
				menuList: [],
			}
		},
		computed: {
			menusData() {
				return this.$store.state.MenusData.CusWebMenus;
			}
		},
		created() {
			this.setMenuList();
		},
		methods: {
			setMenuList() {
				let NodeInfo = this.menusData.filter(item => item.NodeID === '77')[0].Nodes.filter(item => item.NodeID ===
					'79')[0].Nodes.filter(item => item.NodeID === '134')[0].Nodes;
				console.log(11111111, NodeInfo);
				this.menuList = NodeInfo.map(item => {
					item.title = item.NodeName;
					item.auth = item.Buttons.map(item1 => item1.NodeName);
					if (item.NodeID === '135') {
						//item.component = quotaDefaultRatio;
						item.component = quotaMonth;
					}
					if (item.NodeID === '150') {
						item.component = quotaIms;
					}
					if (item.NodeID === '151') {
						item.component = quotaApply;
					}
					if (item.NodeID === '152') {
						item.component = quotaSummary;
					}
					if (item.NodeID === '153') {
						item.component = quotaCreate;
					}
					if (item.NodeID === '1053') {
						item.component = quotaHistory;
					}
					return item;
				})
			},
			handClick(index) {
				this.current = index;
			}
		}
	}
</script>
<style scoped lang="less">
	.Quota {
		width: 100%;
		height: 100%;
		position: relative;

		.content-menu {
			display: flex;
			align-items: center;
			user-select: none;
			cursor: pointer;

			.menu-item {
				flex: 1;
				height: 40px;
				line-height: 40px;
				text-align: center;
				box-sizing: border-box;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #16181A;
				border: 1px solid #E6E8EB;
			}

			.current {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
				background: #00266D;
				border: 1px solid #00266D;
			}

			.menu-item:nth-child(2) {
				border-left: 0px;
				border-right: 0px;
			}
		}
	}
</style>